module.exports = __webpack_public_path__ + "static/media/010.e53aa46c.png";